import React from "react";
import { CognitoAuth } from "amazon-cognito-auth-js";
import { SandboxManagementClient } from "../client/sandbox-management-client";

export interface AppContextInterface {
    auth: CognitoAuth;
    sandboxManagementClient: SandboxManagementClient;
}

const defaultAppWebDomain = "secure-ai-sandbox-management-beta.auth.us-west-2.amazoncognito.com";
const defaultDomain = "localhost:3000";
const defaultRedirectUri = `http://${defaultDomain}`;
const defaultCognitoAuth = new CognitoAuth({
    AppWebDomain: defaultAppWebDomain,
    ClientId: "uvcudtfiakds9n78o5h6kbu5e",
    RedirectUriSignIn: defaultRedirectUri,
    RedirectUriSignOut: defaultRedirectUri,
    TokenScopesArray: ["openid", "email"],
    UserPoolId: "us-west-2_DwfWRiGl6",
});

export const defaultAppContextValue = {
    auth: defaultCognitoAuth,
    sandboxManagementClient: new SandboxManagementClient(`https://${defaultDomain}`, defaultCognitoAuth),
};

const AppContext = React.createContext<AppContextInterface>(defaultAppContextValue);

export default AppContext;
